"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _Constants = require("FileManagerCore/Constants");

var _resize = _interopRequireDefault(require("FileManagerCore/utils/resize"));

var _UINanoProgressBar = _interopRequireDefault(require("FileManagerCore/components/UINanoProgressBar"));

var _UIIconCircle = _interopRequireDefault(require("UIComponents/icon/UIIconCircle"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _Video = _interopRequireDefault(require("FileManagerCore/components/icons/Video"));

var _ThumbnailOverlay = _interopRequireDefault(require("FileManagerCore/components/ThumbnailOverlay"));

var _InfoIcon = _interopRequireDefault(require("FileManagerLib/components/browser/InfoIcon"));

var _ThumbnailVideoDuration = _interopRequireDefault(require("FileManagerLib/components/browser/ThumbnailVideoDuration"));

var _fileNameAndExtension = require("FileManagerLib/utils/fileNameAndExtension");

var Thumbnail =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Thumbnail, _Component);

  function Thumbnail(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Thumbnail);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Thumbnail).call(this, props));
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Thumbnail, [{
    key: "getImageSrc",
    value: function getImageSrc(image) {
      if (image.has('tempUrl')) {
        return image.get('tempUrl');
      }

      if (image.has('progress')) {
        return image.get('url');
      }

      if (image.get('encoding') === 'svg') {
        return image.get('friendly_url');
      }

      var thumbUrl = image.getIn(['meta', 'thumbs', 'medium', 'friendly_url']);
      var url = thumbUrl || image.get('url');
      url = url + "?t=" + image.get('updated');

      if (image.get('replaced')) {
        return url;
      }

      return (0, _resize.default)(url, {
        width: 240
      });
    }
  }, {
    key: "isSelected",
    value: function isSelected() {
      var _this$props = this.props,
          image = _this$props.image,
          selectedFile = _this$props.selectedFile;
      return selectedFile && selectedFile.get('id') === image.get('id');
    }
  }, {
    key: "handleSelect",
    value: function handleSelect() {
      var _this$props2 = this.props,
          onSelect = _this$props2.onSelect,
          image = _this$props2.image;

      if (this.isSelected()) {
        onSelect(null, {
          target: 'thumbnail'
        });
      } else {
        onSelect(image, {
          target: 'thumbnail'
        });
      }
    }
  }, {
    key: "handleInsert",
    value: function handleInsert() {
      var _this$props3 = this.props,
          onInsert = _this$props3.onInsert,
          image = _this$props3.image;
      onInsert(image);
    }
  }, {
    key: "renderVideoPreview",
    value: function renderVideoPreview(image, thumbnailTitle) {
      return _react.default.createElement("div", {
        className: "thumbnail__video-wrapper",
        title: thumbnailTitle
      }, _react.default.createElement(_Video.default, {
        className: "thumbnail__video-icon",
        size: 30
      }), _react.default.createElement(_UINanoProgressBar.default, {
        className: "thumbnail__progress",
        value: image.get('progress'),
        color: colors.CALYPSO
      }), _react.default.createElement("div", {
        className: "thumbnail__preview-overlay"
      }));
    }
  }, {
    key: "renderImagePreview",
    value: function renderImagePreview(image, thumbnailTitle) {
      return _react.default.createElement("div", {
        className: "thumbnail__image-wrapper",
        title: thumbnailTitle
      }, _react.default.createElement("img", {
        alt: thumbnailTitle,
        className: "thumbnail__image",
        src: this.getImageSrc(image)
      }), _react.default.createElement(_UINanoProgressBar.default, {
        className: "thumbnail__progress",
        value: image.get('progress'),
        color: colors.CALYPSO
      }), _react.default.createElement("div", {
        className: "thumbnail__preview-overlay"
      }));
    }
  }, {
    key: "renderGenericVideoThumbnail",
    value: function renderGenericVideoThumbnail(thumbnailTitle) {
      return _react.default.createElement("div", {
        className: "thumbnail__video-wrapper",
        title: thumbnailTitle
      }, _react.default.createElement(_UILink.default, {
        use: "unstyled",
        onClick: this.handleInsert
      }, _react.default.createElement(_ThumbnailOverlay.default, null), _react.default.createElement(_Video.default, {
        className: "thumbnail__video-icon",
        size: 30
      })), _react.default.createElement(_UILink.default, {
        className: (0, _classNames.default)('thumbnail__info-button', {
          'is-selected': this.isSelected()
        }),
        use: "unstyled",
        onClick: this.handleSelect
      }, _react.default.createElement(_InfoIcon.default, null)));
    }
  }, {
    key: "renderBlockIcon",
    value: function renderBlockIcon() {
      var image = this.props.image;
      return _react.default.createElement(_UITooltip.default, {
        title: image.get('notSupportedReason')
      }, _react.default.createElement(_UIIconCircle.default, {
        name: "block",
        className: "thumbnail-disabled-icon",
        backgroundColor: colors.OBSIDIAN,
        color: colors.OLAF,
        size: 7,
        innerStyles: {
          padding: 0,
          transform: 'scale(2.6)'
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var image = this.props.image;

      var isVideo = image.get('type') === _Constants.FileTypes.MOVIE;

      var disabled = image.get('notSupported');
      var thumbnailTitle = (0, _fileNameAndExtension.getFileNameAndExtension)(image);

      if (image.has('progress')) {
        if (isVideo) {
          return this.renderVideoPreview(image, thumbnailTitle);
        }

        return this.renderImagePreview(image, thumbnailTitle);
      }

      if (isVideo && !image.hasIn(['meta', 'thumbs', 'medium', 'friendly_url'])) {
        return this.renderGenericVideoThumbnail(thumbnailTitle);
      }

      var className = (0, _classNames.default)('thumbnail__image-wrapper', 'image__transparency-checkboard', {
        thumbnail_disabled: disabled
      });
      return _react.default.createElement("div", {
        title: thumbnailTitle
      }, disabled && this.renderBlockIcon(), _react.default.createElement(_UILink.default, {
        use: "unstyled",
        onClick: this.handleInsert,
        disabled: disabled
      }, _react.default.createElement(_ThumbnailOverlay.default, null), isVideo && _react.default.createElement(_ThumbnailVideoDuration.default, {
        duration: image.getIn(['meta', 'duration'])
      }), _react.default.createElement("div", {
        className: className
      }, _react.default.createElement("img", {
        alt: thumbnailTitle,
        className: "thumbnail__image",
        src: this.getImageSrc(image)
      }))), _react.default.createElement(_UILink.default, {
        className: (0, _classNames.default)('thumbnail__info-button', {
          'is-selected': this.isSelected()
        }),
        use: "unstyled",
        onClick: this.handleSelect
      }, _react.default.createElement(_InfoIcon.default, null)));
    }
  }]);
  return Thumbnail;
}(_react.Component);

exports.default = Thumbnail;
Thumbnail.propTypes = {
  selectedFile: _react.PropTypes.instanceOf(_immutable.default.Map),
  image: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
  onSelect: _react.PropTypes.func.isRequired,
  onInsert: _react.PropTypes.func.isRequired
};
module.exports = exports.default;